import { Outlet, useLocation } from 'react-router-dom';
import ThemeToggle from '@/components/ThemeToggle';

// The landing page draws its own header (with its own theme switch); every other public page,
// the sign-in and registration screens, gets the switch in the corner.
export default function PublicLayout() {
  const { pathname } = useLocation();
  const landing = pathname === '/';
  return (
    <div className="min-h-svh bg-background relative">
      {!landing && (
        <div className="absolute top-4 right-4">
          <ThemeToggle />
        </div>
      )}
      <Outlet />
    </div>
  );
}
